var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CabeceraModalCrearBase",
    _vm._g(
      {
        attrs: {
          titulo: _vm.titulo,
          "titulo-confirmacion": _vm.$t(
            "mensajes.mensajesAbandono.crear.titulo"
          ),
          "cuerpo-confirmacion": _vm.$t(
            "mensajes.mensajesAbandono.crear.mensaje"
          ),
          "texto-btn-aceptar": _vm.$t(
            "mensajes.mensajesAbandono.crear.btnAceptar"
          ),
          "texto-btn-cancelar": _vm.$t(
            "mensajes.mensajesAbandono.crear.btnCancelar"
          )
        }
      },
      _vm.$listeners
    ),
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }